module.exports = __webpack_public_path__ + "6f7d9550b5e5ddc819492f0996e88395.fbx";